/* global clearTimeout */
import deviceMenu from '@js/common/deviceMenu.js';
import {
    initSVGBtns,
    updateFocusedClass,
    headeraddClass,
    slideToggle,
} from '@js/common/customFunctions.js';

const mainHeader = document.querySelector('header.main-header');

deviceMenu();
headeraddClass();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    initSVGBtns();
    initResponsiveTables();

    /* Show search bar on click start */
    const searchButton = document.querySelector('header.main-header .header-search .header-search-btn');
    const searchWrap = searchButton.parentNode.querySelector('.search-wrap');
    const body = document.body;

    if (searchButton) {
        searchButton.addEventListener('click', function(e) {
            e.stopPropagation();
            this.classList.toggle('is-click');
            searchWrap.classList.toggle('is-open');
            body.classList.toggle('scroll-fixed');

            setTimeout(() => {
                const searchInput = this.parentElement.querySelector('input[type="search"]');
                if (searchInput) {
                    searchInput.focus();
                }
            }, 100);
        });
    }

    // Hide search bar on click
    const overlay = document.querySelector('header.main-header .search-wrap .h-search-overlay');
    const closeButton = document.querySelector('header.main-header .search-wrap .h-search-close');

    function closeSearchPanel() {
        searchButton.classList.remove('is-click');
        searchWrap.classList.remove('is-open');
        body.classList.remove('scroll-fixed');
    }

    if (overlay) {
        overlay.addEventListener('click', closeSearchPanel);
    }
    if (closeButton) {
        closeButton.addEventListener('click', closeSearchPanel);
    }
    /* Show search bar on click end */

    // =========================
    // Home Hero Video autoplay
    // =========================
    const homeHeroes = document.querySelectorAll('.home-hero-section');
    homeHeroes.forEach((hero) => {
        const video = hero.querySelector('.video-inner.html5');
        if (video) {
            setTimeout(() => {
                video.play();
            }, 1600);
        }
    });

    // =========================
    // Set submenu height
    // =========================
    const topMenuItems = mainHeader.querySelectorAll('.navigation ul.menu > li.menu-v2');
    topMenuItems.forEach(function(menuItem) {
        // Get ALL sub-menus inside this menu-v2
        const subMenus = menuItem.querySelectorAll('ul.sub-menu');
        if (!subMenus.length) {
            return;
        }
        let maxHeight = 0;

        subMenus.forEach(function(subMenu) {
            const height = subMenu.scrollHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Store value if needed
        menuItem.dataset.submenuHeight = maxHeight;

        // Set CSS variable (recommended)
        menuItem.style.setProperty('--submenu-height', maxHeight + 'px');

        // =========================
        // 2️⃣ Set default active first child & hover
        // =========================
        const hoverSubMenus = menuItem.querySelectorAll(':scope > ul.sub-menu');
        hoverSubMenus.forEach(function(subMenu) {
            // 1️⃣ First direct child <li> active by default
            const firstLi = subMenu.querySelector(':scope > li');
            if (firstLi) {
                firstLi.classList.add('is-active');
            }

            // 2️⃣ Hover logic for direct children only
            const liItems = subMenu.querySelectorAll(':scope > li');
            liItems.forEach((menuItem) => {
                const link = menuItem.querySelector(':scope > a');
                if (!link) {
                    return;
                }
                if (menuItem.classList.contains('menu-item-has-children')) {
                    const href = link.getAttribute('href');
                    let clickedOnce = false;

                    link.addEventListener('click', (e) => {
                        e.stopPropagation();
                        // Case 1: javascript:void(0)
                        if (href === 'javascript:void(0)' || href === '#') {
                            e.preventDefault();
                            liItems.forEach((item) => {
                                if (item !== menuItem) {
                                    item.classList.remove('is-active');
                                }
                            });

                            menuItem.classList.add('is-active');
                            return;
                        }

                        // Case 2: real link
                        if (!menuItem.classList.contains('is-active')) {
                            e.preventDefault(); // stop navigation on first click

                            liItems.forEach((item) => {
                                if (item !== menuItem) {
                                    item.classList.remove('is-active');
                                }
                            });

                            menuItem.classList.add('is-active');
                            clickedOnce = true;
                        } else if (clickedOnce) {
                            clickedOnce = false;
                        }
                    });
                }
            });
        });
    });

    // =========================
    // Click to open submenu
    // =========================
    const menuItems = mainHeader.querySelectorAll('.navigation ul.menu > li');
    menuItems.forEach((menuItem) => {
        const link = menuItem.querySelector(':scope > a');
        if (!link) {
            return;
        }
        if (menuItem.classList.contains('menu-item-has-children')) {
            const href = link.getAttribute('href');
            let clickedOnce = false;

            link.addEventListener('click', (e) => {
                e.stopPropagation();
                // Case 1: javascript:void(0)
                if (href === 'javascript:void(0)' || href === '#') {
                    e.preventDefault();
                    menuItems.forEach((item) => {
                        if (item !== menuItem) {
                            item.classList.remove('is-open');
                        }
                    });

                    menuItem.classList.add('is-open');
                    return;
                }

                // Case 2: real link
                if (!menuItem.classList.contains('is-open')) {
                    e.preventDefault(); // stop navigation on first click

                    menuItems.forEach((item) => {
                        if (item !== menuItem) {
                            item.classList.remove('is-open');
                        }
                    });

                    menuItem.classList.add('is-open');
                    clickedOnce = true;
                } else if (clickedOnce) {
                    clickedOnce = false;
                }

                menulang.forEach(function(menuItem) {
                    menuItem.parentNode.classList.remove('is-open');
                });
            });
        }
    });

    // =========================
    // Click to Language menu
    // =========================
    const menulang = mainHeader.querySelectorAll('.menu-right .header-global-btn');
    const mbMenulang = mainHeader.querySelectorAll('.mbnav__world .language-wrap');

    menulang.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(event) {
            event.stopPropagation();
            menuItem.parentNode.classList.toggle('is-open');
            menuItems.forEach(function(menuItem) {
                menuItem.classList.remove('is-open');
            });
        });
    });

    mbMenulang.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(event) {
            event.stopPropagation();
            const langMenu = menuItem.nextElementSibling;
            menuItem.parentNode.classList.toggle('is-open');
            slideToggle(langMenu);
        });
    });

    /* Form focus Function Start */
    document.addEventListener('click', function(event) {
        event.stopPropagation();
        document.querySelectorAll('.is-open').forEach(el => {
            el.classList.remove('is-open');
        });

        document.querySelectorAll('.tab-outline').forEach(el => {
            el.classList.remove('tab-outline');
        });

        document.querySelectorAll('.menu-focus').forEach(el => {
            el.classList.remove('menu-focus');
        });
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            document.querySelectorAll('.is-click, .is-open, .scroll-fixed, .is-active').forEach(el => {
                el.classList.remove(
                    'is-click',
                    'is-open',
                    'scroll-fixed',
                    'is-active',
                );
            });
        }
    });

    /* Form focus Function End */

    // =========================
    // Click to scroll to section
    // =========================
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a:not(.skip-link)');
        if (!link) {
            return;
        }

        const href = link.getAttribute('href');

        if (href && href.startsWith('#')) {
            e.preventDefault();

            const targetId = href?.replace('#', '');
            if (!targetId) {
                return;
            }

            const targetElement = document.querySelector(`[data-id="${targetId}"]`);
            if (!targetElement) {
                return;
            }

            const header = document.querySelector('header.main-header');
            const headerHeight = header ? header.offsetHeight : 0;

            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });
        }
    });

});

/* Use jQuery code Start
------------------------------------------------------------------------------*/
(function($) {
    /* Tab outline start */
    $(document).on('keyup', 'a, button', function(e) {
        $(this).each(function() {
            if (e.key === 'Tab' || e.keyCode === 9) {
                if (!$(this).parents('nav').length) {
                    $('.menu-focus').removeClass('menu-focus');
                }
                $('.tab-outline').removeClass('tab-outline');
                $(this).addClass('tab-outline');
                if ($(this).parent('li').find('ul').length > 0) {
                    $(this).parent().addClass('menu-focus').siblings().removeClass('menu-focus');
                } else {
                    if (!$(this).parents('.menu-item-has-children').hasClass('menu-focus')) {
                        $('.menu-focus').removeClass('menu-focus');
                    }
                }
            }
        });
    });
    /* Tab outline end */

    /* Form focus Function Start */
    if (typeof gform !== 'undefined') {
        // Cache form field elements
        const fields = document.querySelectorAll('.gform-style .gfield input, .gform-style .gfield textarea, .gform-style .gfield select');
        updateFocusedClass(fields);

        $(document).on('gform_post_render', function(event, form_id, current_page) {
            const formStyle = document.querySelector('.form-style');

            if (formStyle) {
                const fields = formStyle.querySelectorAll('input, textarea, select');
                updateFocusedClass(fields);
            }
        });
    }

    if (document.querySelector('.form-style')) {
        const fields = document.querySelectorAll('.form-style .field input, .form-style .field textarea, .form-style .field select');
        updateFocusedClass(fields);
    }
    /* Form focus Function End */

    const mainHeader = $('header.main-header');

    function scrollToAnchor() {
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1).toLowerCase();

            const targetElement = $('#' + targetId + '');

            if (targetElement.length) {
                $('html, body').animate({
                    scrollTop: targetElement.offset().top - mainHeader.outerHeight() - 10,
                }, 1000);
            }
        }
    }
    // Run on page load
    $(window).on('load', scrollToAnchor);

    // Run when hash changes (URL bar or clicks)
    $(window).on('hashchange', scrollToAnchor);
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */


/**
 * Initializes responsive behavior for HTML tables:
 * - Wraps all <table> elements (excluding those with .no-wrap) in a .wc-table div.
 * - Further wraps them in a .table-wrapper div for layout control.
 * - On mobile viewports (<768px), transforms tables into column-based blocks for better readability.
 * - Reverts to normal tables on larger viewports.
 * - Handles window resizing with debounce to toggle views dynamically.
 */
function initResponsiveTables() {
    // Wrap tables not marked with .no-wrap in a .wc-table div
    function wrapWCtables() {
        document.querySelectorAll('table:not(.no-wrap)').forEach(table => {
            const wrapper = document.createElement('div');
            wrapper.className = 'wc-table';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }

    // Wrap .wc-table tables in a .table-wrapper div if not already wrapped
    function wrapTables() {
        document.querySelectorAll('.wc-table table').forEach(function(table) {
            if (!table.parentElement.classList.contains('table-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    }

    // Build mobile view for a given wrapper
    function buildMobileTableView(wrapper) {
        const table = wrapper.querySelector('table');
        if (!table || wrapper.querySelector('.mobile-table-view')) {
            return;
        }

        const rows = table.querySelectorAll('tbody tr');
        if (rows.length === 0) {
            return;
        }

        const numColumns = rows[0].children.length;
        const columns = Array.from({
            length: numColumns,
        }, () => []);

        rows.forEach((row, rowIndex) => {
            Array.from(row.children).forEach((cell, colIndex) => {
                columns[colIndex].push({
                    isHeader: rowIndex === 0,
                    content: cell.innerHTML.trim(),
                });
            });
        });

        const mobileView = document.createElement('div');
        mobileView.className = 'mobile-table-view';

        columns.forEach((colData) => {
            const colBlock = document.createElement('div');
            colBlock.className = 'column-block';

            colData.forEach((cell) => {
                const div = document.createElement('div');
                div.className = cell.isHeader ? 'column-header' : 'column-cell';
                div.innerHTML = cell.content;
                colBlock.appendChild(div);
            });

            mobileView.appendChild(colBlock);
        });

        table.insertAdjacentElement('afterend', mobileView);
    }

    // Responsive logic: add/remove mobile view based on screen size
    function handleResponsiveTables() {
        wrapTables();

        document.querySelectorAll('.table-wrapper').forEach(wrapper => {
            const isMobile = window.innerWidth < 768;
            const hasMobileView = wrapper.querySelector('.mobile-table-view');

            if (isMobile && !hasMobileView) {
                buildMobileTableView(wrapper);
            }

            if (!isMobile && hasMobileView) {
                wrapper.querySelector('.mobile-table-view').remove();
            }
        });
    }

    // Initialize all responsive table logic
    wrapWCtables();
    handleResponsiveTables();

    // Resize listener with debounce
    window.addEventListener('resize', () => {
        clearTimeout(window._tableResizeTimeout);
        window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
    });
};